<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Teams</router-link> | 
      <router-link to="/leaderboard">Leaderboard</router-link> |
      <router-link to="/teams">Team Details</router-link> | 
      <router-link to="/playersgrid">Players</router-link> | 
      <router-link to="/misc">Misc</router-link>
    </div>
    <div v-if="dataLoadFailed" class="coming-soon-banner">
      <h2>{{ selectedYear }} Season Coming Soon!</h2>
      <p>Data for the {{ selectedYear }} season is not yet available. Check back when the season starts!</p>
    </div>
    <router-view v-else />
    <!-- <Footer /> -->
  </div>
</template>

<script>
import getTeamsMixin from '@/data/get-teams-mixin.js'
import {mapActions, mapState} from 'vuex';
import Footer from '@/components/Footer.vue';

export default {
  name: 'App',
  components: {
    Footer
  },
  mixins: [getTeamsMixin],
  computed: {
    ...mapState('teamData', ['dataLoadFailed', 'selectedYear'])
  },
  created() {
    this.initializeYearFromStorage();
  },
  methods:{
    ...mapActions('teamData', ['initializeYearFromStorage'])
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.coming-soon-banner {
  max-width: 600px;
  margin: 80px auto;
  padding: 40px 30px;
  background-color: #f0f7f4;
  border: 2px solid #42b983;
  border-radius: 12px;
  text-align: center;

  h2 {
    color: #2c3e50;
    margin-bottom: 15px;
    font-size: 28px;
  }

  p {
    color: #495057;
    font-size: 16px;
    line-height: 1.5;
  }
}
</style>
